import type { LeadSummary } from 'app/features/leads/services/gym-finder/types';

export const LEADS_FIXTURES: LeadSummary[] = [
  {
    id: 'lead-1',
    athleteName: 'Alex Morgan',
    athleteEmail: 'alex.morgan@example.com',
    enquiryType: 'Session request',
    status: 'new',
    receivedAt: '2026-05-20T09:30:00.000Z',
    message: 'Hi, I would like to book an intro session at your gym.',
  },
  {
    id: 'lead-2',
    athleteName: 'Jordan Lee',
    athleteEmail: 'jordan.lee@example.com',
    enquiryType: 'General enquiry',
    status: 'contacted',
    receivedAt: '2026-05-19T14:15:00.000Z',
    message: 'Could you share your class schedule and pricing?',
  },
  {
    id: 'lead-3',
    athleteName: 'Sam Taylor',
    athleteEmail: 'sam.taylor@example.com',
    enquiryType: 'Trial visit',
    status: 'attended',
    receivedAt: '2026-05-18T11:00:00.000Z',
    message: 'I am interested in trying a HYROX class this week.',
  },
  {
    id: 'lead-4',
    athleteName: 'Riley Chen',
    athleteEmail: 'riley.chen@example.com',
    enquiryType: 'Session request',
    status: 'new',
    receivedAt: '2026-05-17T16:45:00.000Z',
    message: 'Looking for coaching ahead of my first race.',
  },
];
